module.exports = __webpack_public_path__ + "static/media/avatar.a02f209c.svg";